import { Box, useTheme } from "@mui/material";
import React from "react";

import { useGetUnreadNotificationsCount } from "../../_hooks/useGetUnreadNotificationsCount";

export const UnreadCountBadge = () => {
  const theme = useTheme();
  const { data, isLoading } = useGetUnreadNotificationsCount();

  if (isLoading || !data || data.count === 0) {return null;}

  return (
    <Box
      component="span"
      sx={{
        ml: "auto",
        px: 1,
        py: 0.25,
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 600,
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.grey[200],
      }}
    >
      {data.count}
    </Box>
  );
};
